<template>
  <q-btn v-if="hasVIN" class="btn tw-document-trigger-btn svg-container" :class="hasOTS ? 'badge-warning' : ''" @click="toggleShowOts" :loading="isLoading" floating>
    <q-badge v-if="hasOTS && otsCount > 0" color="red" floating>
      {{ otsCount }}
    </q-badge>
    <q-icon name="car_crash" size="md" :color="hasOTS ? 'white' : 'white'" />
    <q-tooltip>{{ hasOTS ? 'Opérations Techniques Spéciales détectées' : 'Vérifier les OTS' }}</q-tooltip>
    <template v-slot:loading>
      <q-spinner-facebook />
    </template>
  </q-btn>
  <OtsDialog v-if="showOtsDialog" />
</template>

<script lang="ts">
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import OtsDialog from "./OtsDialog.vue";
import { useRoute } from "vue-router";
import { globalConfig } from "@/utils";
import { checkOtsExist, getOtsSolutionsByVin } from "@/store/services/ots/otsService";

@Options({
  components: { OtsDialog }
})
export default class OtsButton extends Vue {
  hasOTS = false;
  otsCount = 0;
  isLoading = false;

  async toggleShowOts() {
    if (!this.chassisReference) {
      (this as any).$q.notify({
        message: 'Aucun VIN renseigné pour ce véhicule',
        color: 'warning',
        icon: 'warning'
      });
      return;
    }

    // Check if OTS exist before opening modal
    this.isLoading = true;
    try {
      const otsData = await checkOtsExist(this.chassisReference);

      if (otsData) {
        // OTS found, open the modal
        return store.dispatch('orderModule/toggleShowOts');
      } else {
        // No OTS found
        (this as any).$q.notify({
          message: 'Aucun OTS trouvé pour ce véhicule',
          color: 'positive',
          icon: 'check_circle'
        });
      }
    } catch (error: any) {
      console.error('Error checking OTS:', error);
      (this as any).$q.notify({
        message: error.message || 'Erreur lors de la vérification des OTS',
        color: 'negative',
        icon: 'error'
      });
    } finally {
      this.isLoading = false;
    }
  }

  get showOtsDialog() {
    return store.state.orderModule.showOts;
  }

  closeOtsDialog() {
    store.state.orderModule.showOts = false;
  }

  get order() {
    if (this.currentRoute === 'TaskDetail') {
      return store.state.taskModule.order;
    } else {
      return store.state.orderModule.order;
    }
  }

  get recoverState() {
    const orderState = localStorage.getItem(globalConfig.storageKeys.orderTask);
    const orderResourceUid = orderState ? JSON.parse(orderState).resourceUid : "";
    return orderResourceUid;
  }

  get currentRoute() {
    return useRoute().name;
  }

  get chassisReference(): string {
    const order = this.order;
    if (order && order.orderItems && order.orderItems.length > 0) {
      const orderItem = order.orderItems[0];
      if (orderItem.orderAssets && orderItem.orderAssets.length > 0) {
        return orderItem.orderAssets[0]?.chassisReference || "";
      }
    }
    return "";
  }

  get hasVIN(): boolean {
    return !!this.chassisReference;
  }

  get orderReference(): string {
    return this.order?.reference || "";
  }

  async checkForOts() {
    if (!this.chassisReference) {
      this.hasOTS = false;
      this.otsCount = 0;
      return;
    }

    const orderId = this.order?.resourceUid;
    if (!orderId) {
      console.warn("No orderId available for OTS cache");
      return;
    }

    try {
      this.isLoading = true;
      console.log("Auto-checking OTS for VIN:", this.chassisReference, "Order:", orderId);

      // Appel API avec cache - Créera automatiquement OtsHistory
      const response = await getOtsSolutionsByVin(this.chassisReference, {
        locale: "fr_FR",
        orderId: orderId,
        useCache: true  // Utilise cache et crée OtsHistory si nécessaire
      });

      this.hasOTS = response && response.totalElements > 0;
      this.otsCount = response?.totalElements || 0;

      console.log("OTS check result:", this.hasOTS, "Count:", this.otsCount);

    } catch (error) {
      console.error("Error auto-checking OTS:", error);
      this.hasOTS = false;
      this.otsCount = 0;
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.checkForOts();
  }
}
</script>

<style scoped>
.badge-warning {
  background-color: #ffa800 !important;
}
</style>
